/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerProject_ProjectVersions.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Project Versions
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, June 17, 2019 - 09:49:02 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      06/17/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    PROJECTVERSION_LIST_CONTAINER_LOADED,
    PROJECTVERSION_LIST_CONTAINER_UNLOADED,
    PROJECTVERSION_LIST_TABLE_LOADED,
    PROJECTVERSION_LIST_TABLE_UNLOADED,

    PROJECTVERSION_SELECT_ROW,
    PROJECTVERSION_ADD,
    PROJECTVERSION_EDIT,
    PROJECTVERSION_DELETE,
    PROJECTVERSION_OPEN_WARNING,
    PROJECTVERSION_CLOSE_WARNING,
    PROJECTVERSION_DELETE_DISABLE,

    PROJECTVERSION_UPDATE_VALUE,

    PROJECTVERSION_EDIT_CONTAINER_LOADED,
    PROJECTVERSION_EDIT_CONTAINER_UNLOADED,
    PROJECTVERSION_EDIT_FORM_LOADED,
    PROJECTVERSION_EDIT_FORM_UNLOADED,
    PROJECTVERSION_EDIT_DATA_LOAD,
    PROJECTVERSION_EDIT_CONTAINER_SUBMIT,
    PROJECTVERSION_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeProject_ProjectVersions';

const defaultState = {
    refreshList: false,
    danger: false,
    projectversionid: 0,
    projectid: 0,
    name: '',
    description: '',
    orderid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case PROJECTVERSION_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                projectversions: action.payload[0] ? action.payload[0].records : null,
                itempath: action.payload[1] ? action.payload[1].records : []
            }
        case PROJECTVERSION_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case PROJECTVERSION_SELECT_ROW:
            return {
                ...state,
                projectversionid: action.id
            }
        case PROJECTVERSION_ADD:
            return {
                ...state
            }
        case PROJECTVERSION_EDIT:
            return {
                ...state,
                projectversionid: action.id
            }
        case PROJECTVERSION_DELETE:
            return {
                ...state,
                projectversionid: null
            }
        case PROJECTVERSION_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case PROJECTVERSION_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case PROJECTVERSION_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case PROJECTVERSION_EDIT_CONTAINER_LOADED:
        case PROJECTVERSION_EDIT_DATA_LOAD:
            return {
                ...state,
                projectversionid: action.payload[0] ? action.payload[0].projectversionid : 0,
                projectid: action.payload[0] ? action.payload[0].projectid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                orderid: action.payload[0] ? action.payload[0].orderid : 0,
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case PROJECTVERSION_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case PROJECTVERSION_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case PROJECTVERSION_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case PROJECTVERSION_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case PROJECTVERSION_LIST_CONTAINER_UNLOADED:
        case PROJECTVERSION_LIST_TABLE_UNLOADED:
        case PROJECTVERSION_EDIT_CONTAINER_UNLOADED:
        case PROJECTVERSION_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerProject_ProjectVersions.js